import VideoBackground from "./VideoBackground";
import HelpingPoints from "./HelpingPoints";

const HowItHelps = () => {
    return (
        <div className="flex flex-col items-center">
          <VideoBackground />
          <HelpingPoints />
        </div>
    )
}

export default HowItHelps;